import { Component } from 'base/js/aem';

class TeaserFilter extends Component {
    init() {
        this.teasers = this.element.querySelectorAll('.cmp-simple-modal');
        this.categories = new Set([ ...this.teasers ].map(teaser => teaser.dataset.tags?.split(',')).flat());
        this.navTabs = this.element.querySelector('.cmp-teaser-filter__nav-tabs');
        this.tabTemplate = this.element.querySelector('[data-template-id="teaser-filter-item"]');
        this.createTabs();
    }

    createTabs() {
        this.categories.forEach(category => {
            if (category !== undefined) {
                const tab = this.tabTemplate.content.cloneNode(true);
                const tabLink = tab.querySelector('a');
                tabLink.textContent = category;
                tabLink.dataset.tag = category;
                this.navTabs.appendChild(tab);
                tab.addEventListener('click', this);
            }
        });
        this.navTabs.addEventListener('click', this);
        this.navTabs.classList.remove('d-none');
    }

    handleEvent(e) {
        if (e.type === 'change') {
            this.filterTeasers();
        } else if (e.type === 'click') {
            this.tabFilter(e);
        }
    }

    unsetCurrent() {
        this.navTabs.querySelectorAll('a').forEach(tab => {
            tab.ariaCurrent = 'false';
            tab.classList.remove('active');
        });
    }

    tabFilter(e) {
        e.preventDefault();
        const selectedTag = e.target.dataset.tag;
        this.filterTeasers(selectedTag);
        this.unsetCurrent();
        e.target.ariaCurrent = 'true';
        e.target.classList.add('active');
    }
    filterTeasers(tag) {
        this.teasers.forEach(teaser => {
            const teaserTags = teaser.dataset.tags ? teaser.dataset.tags.split(',') : [];
            teaser.parentElement.style.display = tag === 'All' || teaserTags.includes(tag) ? '' : 'none';
        });
    }
}

export { TeaserFilter };
